import type { HttpClient } from '~/api/client';
import { httpClient } from '~/api/client';
import type { Buyer, BuyerMyPage, BuyerPlusMembership } from '~/api/model';

// Response 타입 (Zod Model 재사용 — OAISchema 금지, api-typegen §0)
type BuyerResponse = Buyer;
type BuyerPlusMembershipResponse = BuyerPlusMembership;
type BuyerMyPageResponse = BuyerMyPage;

export interface BuyerDataSource {
  // Query
  getBuyer(): Promise<BuyerResponse>;
  getBuyerPlusMembership(): Promise<BuyerPlusMembershipResponse>;
  getBuyerMyPage(): Promise<BuyerMyPageResponse>;
}

export class BuyerDataSourceImpl implements BuyerDataSource {
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly client: HttpClient = httpClient) {}

  async getBuyer() {
    return this.client.request<BuyerResponse>({
      url: '/api/market-place/v1/buyer',
      method: 'get',
    });
  }

  async getBuyerPlusMembership() {
    return this.client.request<BuyerPlusMembershipResponse>({
      url: '/api/market-place/v1/buyer/plus-membership',
      method: 'get',
    });
  }

  async getBuyerMyPage() {
    return this.client.request<BuyerMyPageResponse>({
      url: '/api/market-place/v1/buyer/my-page',
      method: 'get',
    });
  }
}

export const buyerDataSource = new BuyerDataSourceImpl();
